;(function ($) {
/*===============================================
  Search Result Page Grid
===============================================*/

if ($('body').hasClass('search-results')){
    const searchResult =  $('.search__content');
    searchResult.isotope({
        // options
        itemSelector: '.grid__item',
        masonry: {
            columnWidth: '.grid__sizer',
            gutter: '.grid__gutter',
        },
    });
    searchResult.imagesLoaded().done(function () {
        searchResult.isotope('layout');
    });
}
})(jQuery)
